import { useState } from "react";

import Box from "../../layout/Box/Box.web";
import Flex from "../../layout/Flex/Flex.web";
import ParsedHtml from "../ParsedHtml/ParsedHtml.web";
import Text from "../Text/Text.web";
import { ReadMoreProps } from "./ReadMore.props";

const ReadMore = ({
  truncateTextLines = 2,
  descriptionColor = "fg",
  ...props
}: ReadMoreProps) => {
  const { descriptionHtml, openReadMoreText, closeReadMoreText } = props;
  const [openReadMore, setOpenReadMore] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);

  const buttonText = openReadMore ? closeReadMoreText : openReadMoreText;
  // if openReadMore is true then we should always show the button.
  const showReadMoreButton = isTruncated || openReadMore;

  return descriptionHtml ? (
    <Flex mt="md" direction="column">
      <Flex width="100%">
        <Box color={descriptionColor}>
          <ParsedHtml
            truncateTextLines={openReadMore ? undefined : truncateTextLines}
            htmlString={descriptionHtml}
            onTruncateChange={setIsTruncated}
          />
        </Box>
      </Flex>

      {showReadMoreButton && (
        <Text
          size="sm"
          cursor="pointer"
          width="fit-content"
          color="fg.muted"
          textDecoration="underline"
          onClick={() => setOpenReadMore(!openReadMore)}
        >
          {buttonText}
        </Text>
      )}
    </Flex>
  ) : (
    <></>
  );
};

export default ReadMore;
